
<div class="why-iquanta-modals why-iquanta-modals-lg">
  <div class="modal" id="OtherCoachings" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg px-2">
          <div class="modal-content" *ngIf="showContent">

              <div class="modal-body">
                  <div class="modal-header-card mb-3 position-relative">
                    
                      <div data-dismiss="modal" class="close-button position-absolute">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                              fill="none">
                              <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                              <path
                                  d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                  fill="#1E1515" />
                          </svg>
                      </div>
                  </div>
                  <div class="modal-body-wrapper">

                      <div class="d-flex flex-wrap gap-3">
                          <div class="modal-text modal-right">
                              <div class="d-flex flex-wrap gap-3">
                                  <div class="img ">
                                      <img width="421" height="421" class="img-fluid"
                                          src="https://media.iquanta.in/ui_images/new-home/meam.webp"
                                          loading="lazy" alt="CAT Coaching">
                                  </div>
                                  <div class="video">
                                    <video  controls style="height: 488px;" >
                                      <source src="https://media.iquanta.in/ui_images/home-new-vedio.mp4" type="video/mp4">
                                    </video>
                                  </div>
                              </div>

                          </div>
                        

                        

                      </div>
                  </div>
              </div>

          </div>
      </div>
  </div>
</div>

<div class="course-table table-responsive">
  <table class="table mb-0">
      <thead>
          <tr class="f-medium">
              <th>Course Features</th>
              <th>CAT 2025 Full Course</th>
              <th>CAT 2025 + IIM ABC</th>
              <th>CAT 2025 Full Course Pro</th>
              <th>Other Coachings</th>
          </tr>
      </thead>
      <tbody>

          <tr class="f-light" *ngFor="let data of tableData">
              <td class="d-flex align-items-center">
                  <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                      viewBox="0 0 15 15" fill="none">
                      <g opacity="0.5">
                          <circle cx="7.20303" cy="7.41934" r="6.89053" fill="#6D544A"
                              fill-opacity="0.5" />
                          <circle cx="7.20303" cy="7.41934" r="6.39053" stroke="#917366"
                              stroke-opacity="0.6" />
                      </g>
                  </svg>{{data.text}}
                  <ng-container *ngIf="data.subText"><br>{{data.subText}}</ng-container>
              </td>
              <td>
                  <!-- <img *ngIf="data.img1" [src]="data.img1" alt="CAT 2024"> -->
                  <svg *ngIf="data.img1" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 23 23" fill="none">
                      <circle cx="11.4842" cy="11.4842" r="11.4842"
                          fill="url(#paint0_linear_1074_1869)" />
                      <path
                          d="M18.5018 9.24938L16.8099 7.65625L10.047 14.0243L6.81362 10.9796L5.10352 12.5899L10.0275 17.2264L10.0288 17.2256L10.0297 17.2264L18.5018 9.24938Z"
                          fill="white" />
                      <defs>
                          <linearGradient id="paint0_linear_1074_1869" x1="0" y1="11.4842"
                              x2="22.9684" y2="11.4842" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#E16B3A" />
                              <stop offset="1" stop-color="#B14820" />
                          </linearGradient>
                      </defs>
                  </svg>
                  <svg *ngIf="!data.img1" width="18" height="18" viewBox="0 0 23 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11.4842" cy="12.3357" r="11.4842" fill="#F9F4DD" />
                      <g clip-path="url(#clip0_1074_1739)">
                          <path
                              d="M5.7945 7.95419L7.10211 6.64658C7.13575 6.61303 7.18132 6.59418 7.22883 6.59418C7.27635 6.59418 7.32192 6.61303 7.35556 6.64658L11.4825 10.7735L15.6027 6.63761C15.6203 6.62031 15.6412 6.6068 15.6642 6.59794C15.6872 6.58908 15.7117 6.58505 15.7364 6.5861C15.761 6.58715 15.7851 6.59327 15.8073 6.60406C15.8294 6.61485 15.8491 6.63009 15.8651 6.64882L17.166 7.94522C17.1834 7.96262 17.1971 7.98342 17.2062 8.00633C17.2152 8.02924 17.2195 8.05377 17.2186 8.07838C17.2178 8.103 17.2119 8.12718 17.2013 8.14942C17.1907 8.17166 17.1756 8.19148 17.157 8.20764L13.0436 12.3346L17.1705 16.4615C17.2041 16.4952 17.2229 16.5407 17.2229 16.5882C17.2229 16.6358 17.2041 16.6813 17.1705 16.715L15.8629 18.0248C15.8292 18.0584 15.7837 18.0772 15.7362 18.0772C15.6886 18.0772 15.6431 18.0584 15.6094 18.0248L11.4825 13.8979L7.36453 18.0293C7.34713 18.0468 7.32633 18.0604 7.30342 18.0695C7.28051 18.0785 7.25598 18.0828 7.23137 18.0819C7.20675 18.0811 7.18257 18.0752 7.16033 18.0646C7.13809 18.054 7.11827 18.0389 7.10211 18.0203L5.80123 16.7239C5.78379 16.7065 5.77012 16.6857 5.76107 16.6628C5.75202 16.6399 5.74778 16.6154 5.74862 16.5908C5.74946 16.5662 5.75537 16.542 5.76596 16.5197C5.77655 16.4975 5.79161 16.4777 5.8102 16.4615L9.92144 12.3368L5.7945 8.20988C5.77754 8.19319 5.76408 8.17329 5.75489 8.15134C5.7457 8.12939 5.74097 8.10583 5.74097 8.08204C5.74097 8.05824 5.7457 8.03469 5.75489 8.01274C5.76408 7.99079 5.77754 7.97089 5.7945 7.95419Z"
                              fill="#E80E0E" />
                      </g>
                      <defs>
                          <clipPath id="clip0_1074_1739">
                              <rect width="15.3123" height="15.3123" fill="white"
                                  transform="translate(3.82788 4.67957)" />
                          </clipPath>
                      </defs>
                  </svg>



              </td>
              <td>
                  <svg *ngIf="data.img2" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 23 23" fill="none">
                      <circle cx="11.4842" cy="11.4842" r="11.4842"
                          fill="url(#paint0_linear_1074_1869)" />
                      <path
                          d="M18.5018 9.24938L16.8099 7.65625L10.047 14.0243L6.81362 10.9796L5.10352 12.5899L10.0275 17.2264L10.0288 17.2256L10.0297 17.2264L18.5018 9.24938Z"
                          fill="white" />
                      <defs>
                          <linearGradient id="paint0_linear_1074_1869" x1="0" y1="11.4842"
                              x2="22.9684" y2="11.4842" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#E16B3A" />
                              <stop offset="1" stop-color="#B14820" />
                          </linearGradient>
                      </defs>
                  </svg>
                  <svg *ngIf="!data.img2" width="18" height="18" viewBox="0 0 23 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11.4842" cy="12.3357" r="11.4842" fill="#F9F4DD" />
                      <g clip-path="url(#clip0_1074_1739)">
                          <path
                              d="M5.7945 7.95419L7.10211 6.64658C7.13575 6.61303 7.18132 6.59418 7.22883 6.59418C7.27635 6.59418 7.32192 6.61303 7.35556 6.64658L11.4825 10.7735L15.6027 6.63761C15.6203 6.62031 15.6412 6.6068 15.6642 6.59794C15.6872 6.58908 15.7117 6.58505 15.7364 6.5861C15.761 6.58715 15.7851 6.59327 15.8073 6.60406C15.8294 6.61485 15.8491 6.63009 15.8651 6.64882L17.166 7.94522C17.1834 7.96262 17.1971 7.98342 17.2062 8.00633C17.2152 8.02924 17.2195 8.05377 17.2186 8.07838C17.2178 8.103 17.2119 8.12718 17.2013 8.14942C17.1907 8.17166 17.1756 8.19148 17.157 8.20764L13.0436 12.3346L17.1705 16.4615C17.2041 16.4952 17.2229 16.5407 17.2229 16.5882C17.2229 16.6358 17.2041 16.6813 17.1705 16.715L15.8629 18.0248C15.8292 18.0584 15.7837 18.0772 15.7362 18.0772C15.6886 18.0772 15.6431 18.0584 15.6094 18.0248L11.4825 13.8979L7.36453 18.0293C7.34713 18.0468 7.32633 18.0604 7.30342 18.0695C7.28051 18.0785 7.25598 18.0828 7.23137 18.0819C7.20675 18.0811 7.18257 18.0752 7.16033 18.0646C7.13809 18.054 7.11827 18.0389 7.10211 18.0203L5.80123 16.7239C5.78379 16.7065 5.77012 16.6857 5.76107 16.6628C5.75202 16.6399 5.74778 16.6154 5.74862 16.5908C5.74946 16.5662 5.75537 16.542 5.76596 16.5197C5.77655 16.4975 5.79161 16.4777 5.8102 16.4615L9.92144 12.3368L5.7945 8.20988C5.77754 8.19319 5.76408 8.17329 5.75489 8.15134C5.7457 8.12939 5.74097 8.10583 5.74097 8.08204C5.74097 8.05824 5.7457 8.03469 5.75489 8.01274C5.76408 7.99079 5.77754 7.97089 5.7945 7.95419Z"
                              fill="#E80E0E" />
                      </g>
                      <defs>
                          <clipPath id="clip0_1074_1739">
                              <rect width="15.3123" height="15.3123" fill="white"
                                  transform="translate(3.82788 4.67957)" />
                          </clipPath>
                      </defs>
                  </svg>
              </td>
              <td>
                  <svg *ngIf="data.img3" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 23 23" fill="none">
                      <circle cx="11.4842" cy="11.4842" r="11.4842"
                          fill="url(#paint0_linear_1074_1869)" />
                      <path
                          d="M18.5018 9.24938L16.8099 7.65625L10.047 14.0243L6.81362 10.9796L5.10352 12.5899L10.0275 17.2264L10.0288 17.2256L10.0297 17.2264L18.5018 9.24938Z"
                          fill="white" />
                      <defs>
                          <linearGradient id="paint0_linear_1074_1869" x1="0" y1="11.4842"
                              x2="22.9684" y2="11.4842" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#E16B3A" />
                              <stop offset="1" stop-color="#B14820" />
                          </linearGradient>
                      </defs>
                  </svg>
                  <svg *ngIf="!data.img3" width="18" height="18" viewBox="0 0 23 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11.4842" cy="12.3357" r="11.4842" fill="#F9F4DD" />
                      <g clip-path="url(#clip0_1074_1739)">
                          <path
                              d="M5.7945 7.95419L7.10211 6.64658C7.13575 6.61303 7.18132 6.59418 7.22883 6.59418C7.27635 6.59418 7.32192 6.61303 7.35556 6.64658L11.4825 10.7735L15.6027 6.63761C15.6203 6.62031 15.6412 6.6068 15.6642 6.59794C15.6872 6.58908 15.7117 6.58505 15.7364 6.5861C15.761 6.58715 15.7851 6.59327 15.8073 6.60406C15.8294 6.61485 15.8491 6.63009 15.8651 6.64882L17.166 7.94522C17.1834 7.96262 17.1971 7.98342 17.2062 8.00633C17.2152 8.02924 17.2195 8.05377 17.2186 8.07838C17.2178 8.103 17.2119 8.12718 17.2013 8.14942C17.1907 8.17166 17.1756 8.19148 17.157 8.20764L13.0436 12.3346L17.1705 16.4615C17.2041 16.4952 17.2229 16.5407 17.2229 16.5882C17.2229 16.6358 17.2041 16.6813 17.1705 16.715L15.8629 18.0248C15.8292 18.0584 15.7837 18.0772 15.7362 18.0772C15.6886 18.0772 15.6431 18.0584 15.6094 18.0248L11.4825 13.8979L7.36453 18.0293C7.34713 18.0468 7.32633 18.0604 7.30342 18.0695C7.28051 18.0785 7.25598 18.0828 7.23137 18.0819C7.20675 18.0811 7.18257 18.0752 7.16033 18.0646C7.13809 18.054 7.11827 18.0389 7.10211 18.0203L5.80123 16.7239C5.78379 16.7065 5.77012 16.6857 5.76107 16.6628C5.75202 16.6399 5.74778 16.6154 5.74862 16.5908C5.74946 16.5662 5.75537 16.542 5.76596 16.5197C5.77655 16.4975 5.79161 16.4777 5.8102 16.4615L9.92144 12.3368L5.7945 8.20988C5.77754 8.19319 5.76408 8.17329 5.75489 8.15134C5.7457 8.12939 5.74097 8.10583 5.74097 8.08204C5.74097 8.05824 5.7457 8.03469 5.75489 8.01274C5.76408 7.99079 5.77754 7.97089 5.7945 7.95419Z"
                              fill="#E80E0E" />
                      </g>
                      <defs>
                          <clipPath id="clip0_1074_1739">
                              <rect width="15.3123" height="15.3123" fill="white"
                                  transform="translate(3.82788 4.67957)" />
                          </clipPath>
                      </defs>
                  </svg>
              </td>
              <td>
                  <svg *ngIf="data.img4" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                      viewBox="0 0 23 23" fill="none">
                      <circle cx="11.4842" cy="11.4842" r="11.4842"
                          fill="url(#paint0_linear_1074_1869)" />
                      <path
                          d="M18.5018 9.24938L16.8099 7.65625L10.047 14.0243L6.81362 10.9796L5.10352 12.5899L10.0275 17.2264L10.0288 17.2256L10.0297 17.2264L18.5018 9.24938Z"
                          fill="white" />
                      <defs>
                          <linearGradient id="paint0_linear_1074_1869" x1="0" y1="11.4842"
                              x2="22.9684" y2="11.4842" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#E16B3A" />
                              <stop offset="1" stop-color="#B14820" />
                          </linearGradient>
                      </defs>
                  </svg>
                  <svg *ngIf="!data.img4" width="18" height="18" viewBox="0 0 23 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11.4842" cy="12.3357" r="11.4842" fill="#F9F4DD" />
                      <g clip-path="url(#clip0_1074_1739)">
                          <path
                              d="M5.7945 7.95419L7.10211 6.64658C7.13575 6.61303 7.18132 6.59418 7.22883 6.59418C7.27635 6.59418 7.32192 6.61303 7.35556 6.64658L11.4825 10.7735L15.6027 6.63761C15.6203 6.62031 15.6412 6.6068 15.6642 6.59794C15.6872 6.58908 15.7117 6.58505 15.7364 6.5861C15.761 6.58715 15.7851 6.59327 15.8073 6.60406C15.8294 6.61485 15.8491 6.63009 15.8651 6.64882L17.166 7.94522C17.1834 7.96262 17.1971 7.98342 17.2062 8.00633C17.2152 8.02924 17.2195 8.05377 17.2186 8.07838C17.2178 8.103 17.2119 8.12718 17.2013 8.14942C17.1907 8.17166 17.1756 8.19148 17.157 8.20764L13.0436 12.3346L17.1705 16.4615C17.2041 16.4952 17.2229 16.5407 17.2229 16.5882C17.2229 16.6358 17.2041 16.6813 17.1705 16.715L15.8629 18.0248C15.8292 18.0584 15.7837 18.0772 15.7362 18.0772C15.6886 18.0772 15.6431 18.0584 15.6094 18.0248L11.4825 13.8979L7.36453 18.0293C7.34713 18.0468 7.32633 18.0604 7.30342 18.0695C7.28051 18.0785 7.25598 18.0828 7.23137 18.0819C7.20675 18.0811 7.18257 18.0752 7.16033 18.0646C7.13809 18.054 7.11827 18.0389 7.10211 18.0203L5.80123 16.7239C5.78379 16.7065 5.77012 16.6857 5.76107 16.6628C5.75202 16.6399 5.74778 16.6154 5.74862 16.5908C5.74946 16.5662 5.75537 16.542 5.76596 16.5197C5.77655 16.4975 5.79161 16.4777 5.8102 16.4615L9.92144 12.3368L5.7945 8.20988C5.77754 8.19319 5.76408 8.17329 5.75489 8.15134C5.7457 8.12939 5.74097 8.10583 5.74097 8.08204C5.74097 8.05824 5.7457 8.03469 5.75489 8.01274C5.76408 7.99079 5.77754 7.97089 5.7945 7.95419Z"
                              fill="#E80E0E" />
                      </g>
                      <defs>
                          <clipPath id="clip0_1074_1739">
                              <rect width="15.3123" height="15.3123" fill="white"
                                  transform="translate(3.82788 4.67957)" />
                          </clipPath>
                      </defs>
                  </svg>
              </td>
          </tr>



          <tr *ngIf="pageType != 'cat-2025'" >

              <td></td>
              <td>
                  <div class="header-actions">
                      <button [routerLink]="'/details/cat-full-course'"
                          class="btn d-flex align-item-center pr-2">Buy Now
                          <span
                              class="ml-2 ml-sm-4 d-flex justify-content-center align-items-center rounded-circle border-0">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                  viewBox="0 0 14 14" fill="none">
                                  <path d="M1 7H13M13 7L7 1M13 7L7 13" stroke="#211818"
                                      stroke-width="1.7" stroke-linecap="round"
                                      stroke-linejoin="round" />
                              </svg>
                          </span>


                      </button>
                  </div>

              </td>


              <td>
                  <div  class="header-actions">
                      <button [routerLink]="'/details/cat-2025-full-course-iim-abc-practice-batch'"
                          class="btn d-flex align-item-center pr-2">Buy Now
                          <span
                              class="ml-2 ml-sm-4 d-flex justify-content-center align-items-center rounded-circle border-0">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                  viewBox="0 0 14 14" fill="none">
                                  <path d="M1 7H13M13 7L7 1M13 7L7 13" stroke="#211818"
                                      stroke-width="1.7" stroke-linecap="round"
                                      stroke-linejoin="round" />
                              </svg>
                          </span>
                      </button>
                  </div>
              </td>


              <td>

                  <div class="header-actions">
                      <button [routerLink]="'/details/CAT-2025-full-course-pro'"
                          class="btn btn_bg d-flex align-item-center pr-2">Buy Now
                          <span
                              class="ml-2 ml-sm-4 d-flex justify-content-center align-items-center rounded-circle border-0">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                  viewBox="0 0 14 14" fill="none">
                                  <path d="M1 7H13M13 7L7 1M13 7L7 13" stroke="#FFFDF2"
                                      stroke-width="1.7" stroke-linecap="round"
                                      stroke-linejoin="round" />
                              </svg>
                          </span>
                      </button>
                  </div>
              </td>


              <td style=" vertical-align: bottom;">
                  <div  class="header-actions">
                      <button (click)="showContent = true" data-toggle="modal" data-target="#OtherCoachings"  class="btn d-flex align-item-center pr-2">Buy Now
                          <span
                              class="ml-2 ml-sm-4 d-flex justify-content-center align-items-center rounded-circle border-0 ">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                  viewBox="0 0 14 14" fill="none">
                                  <path d="M1 7H13M13 7L7 1M13 7L7 13" stroke="#211818"
                                      stroke-width="1.7" stroke-linecap="round"
                                      stroke-linejoin="round" />
                              </svg>
                          </span>
                      </button>
                  </div>
              </td>
          </tr>

      </tbody>
  </table>
</div>